<script>
  //  import clickOut from '../mixins/clickout'
  import ClickOut from '../../../utils/directives/clickout'
  import DDMega from './header/DDMega'
  import DDNew from './header/DDNew'
  import Search from './header/Search'
  import Notification from './header/Notification'
  import Profile from './header/Profile'
  import { mapState, mapGetters } from 'vuex'
  import base from './_base'
  // import ULinkNotificationChat from '../../chat/components/LinkNotificationChat'
  import ACL from '../../../domain/acl/tmp-acl'

  export default {
    name: 'appheader',
//    mixins: [clickOut],
    extends: base,
    data () {
      return {
        navbarCollapse: false,
        vtoggle: {
          dd1: false
        }
      }
    },
    computed: {
      ...mapState({
        menuOpen: state => state.app.menuOpen
      }),
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    attached () {},
    methods: {
//      clickOutListener () {
//        this.navbarCollapse = false
//      },
//      toggle: function (target) {
//        this[target] = true
//      }
      toggleNavbarCollapse () {
        this.navbarCollapse = !this.navbarCollapse
      },
      hideNavbarCollapse () {
        this.navbarCollapse = false
      },
      toggle (v) {
        this.vtoggle[v] = !this.vtoggle[v]
      },
      toggleMenu () {
        this.$store.commit('APP/SET_TOGGLE_MENU', !this.menuOpen)
      },
      toggleChat () {
        this.$emit('toggleChat')
        // this.$root.toggleChat()
      },
      updateNotReadedMessagesChat (data) {
        this.$emit('updateNotReadedMessagesChat', data)
      }
    },
    components: {
      DDMega,
      DDNew,
      Search,
      Notification,
      Profile
      // ULinkNotificationChat
    },
    directives: {
      ClickOut
    }
  }
</script>

<template>
  <div id="header" class="app-header navbar hidden-print" role="menu">
    <!-- navbar header -->
    <div class="navbar-header bg-black ">
      <button class="pull-right visible-xs dk" v-click-out="hideNavbarCollapse"
              @click.stop.prevent="toggleNavbarCollapse" target=".navbar-collapse"><i
        class="glyphicon glyphicon-cog"></i></button>
      <button class="pull-right visible-xs" ui-toggle-class="off-screen" target=".app-aside" ui-scroll="app"
              @click.stop.prevent="toggleMenu"><i class="glyphicon glyphicon-align-justify"></i></button>
      <!-- brand -->
      <router-link :to="{ name: 'dashboard.main' }" class="navbar-brand text-lt">
        <img src="~assets/logo_min.png" alt="Logo">
        <span class="hidden-folded m-l-xs font-normal">ERP</span>
      </router-link>
      <!-- / brand -->
    </div>
    <!-- / navbar header -->

    <!-- navbar collapse -->
    <div class="collapse pos-rlt navbar-collapse box-shadow bg-white-only" ref="navbarCollapse"
         :class="{show: navbarCollapse}">
      <!-- buttons -->
      <div class="nav navbar-nav hidden-xs">
        <a v-on:click="_menuFolded(true, 1)" class="btn no-shadow navbar-btn">
          <i v-if="!menuFolded" class="fa fa-dedent fa-fw text"></i> <i v-if="menuFolded" class="fa fa-indent fa-fw"></i>
        </a>
      </div>
      <!-- / buttons -->

      <!-- link and dropdown -->
      <ul class="nav navbar-nav hidden-sm">

        <!--<DDMega/>-->
        <DDNew v-if="ACL.check('restrito_visitante', currentUser.id)"/>
      </ul>
      <!-- / link and dropdown -->

      <!-- search form -->
      <Search/>
      <!-- / search form -->

      <!-- nabar right -->
      <ul class="nav navbar-nav navbar-right">
        <li>
          <!--<ULinkNotificationChat @toggle="toggleChat" @updateNotReaded="updateNotReadedMessagesChat"/>-->
        </li>
        <Notification/>
        <Profile/>
      </ul>
      <!-- / navbar right -->
    </div>
    <!-- / navbar collapse -->
  </div>
</template>




// WEBPACK FOOTER //
// Header.vue?53c24375